import { render } from "./AppDrawer.vue?vue&type=template&id=67faef13&scoped=true&ts=true"
import script from "./AppDrawer.vue?vue&type=script&lang=ts"
export * from "./AppDrawer.vue?vue&type=script&lang=ts"

import "./AppDrawer.vue?vue&type=style&index=0&id=67faef13&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67faef13"]])

export default __exports__